<div class="tile" [ngClass]="{'errorTile' : error}">
    <div class="tileBody" style="height: 20px !important;">
        <app-progress-bar [percentValue]="value"></app-progress-bar>
    </div>
</div>